import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { Divider } from '@material-ui/core';
import Card from '@material-ui/core/Card';
//import ListDetail from "../../ListDetail/ListDetail";
import VendorListDetail from './VendorListDetail';
//searchBar related import
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';

import AlertChip from "../../AlertChip";

import CustomizedTable from "../../CSSComponent/table"

import config from "../../../config/config";
import axios from 'axios';
import { grid_spacing, styles } from '../../CSS/Styles';
let counter = 0;
function createData(name, detailedFlags, actions, carbs, protein, flags) {
    counter += 1;
    return { id: counter, detailedFlags, name, flags, actions, carbs, protein, flags };
}

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const rows = [
    { id: 'name', numeric: false, disablePadding: true, label: 'Vendor Name' },
    { id: 'flags', numeric: true, disablePadding: false, label: 'Flags' }
];



class VendorAlertTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: 'asc',
            orderBy: 'name',
            selected: [],
            data: [
            ],
            fields: [],
            page: 0,
            rowsPerPage: 10,
            details: true,
            filtered: [],
            height:0,
            width: 0,
            nextURL: null
        };
        this.getVendors = this.getVendors.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }


    componentWillMount() {
        this._isMounted = false;
    }
    componentDidMount() {
        this._isMounted = true;
        // console.log("employmrny mounted")
        // console.log(this.props.taskRefresh)
        this.getVendors();
        //console.log("vendor data load finish");
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    componentWillUnmount(){
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    getVendors = () => {
        //console.log("test axios getVendors");
        axios.get(config.entities("vendor"))
            .then(res => {
                console.log(res)
                let vendors = res.data.results.items;
                let fields = res.data.results.table_def;
                this.setState({ data: vendors, fields: fields, filtered: vendors, detailSelected:vendors[0].id, nextURL: res.data.next});
                //console.log(this.state.data);
            })
    }

    nextPage = (nextURL) => {

        axios.get(nextURL)
            .then(res => {
                console.log(res)
                let vendors = res.data.results.items;
                let fields = res.data.results.table_def;
                this.setState(()=>{ this.state.data=this.state.data.concat(vendors); this.state.filtered=this.state.filtered.concat(vendors), this.state.nextURL = res.data.next});
                //console.log(this.state.data);
            })
    }


    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleChangePage = (event, page) => {
        console.log(page)
        if ( page%10 == 4){
            if(this.state.data.length < (page+10)*10 && this.state.nextURL != null){
                // console.log('next: ' + this.state.nextURL)
                this.nextPage(this.state.nextURL)
            }
        }
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    handleAction = (event) => {
        let id = event.id
        this.setState({detailSelected: id});
    }

    //renderChips = (flags) => {
    //    let toReturn = [];
    //    if (flags.high) {
    //        toReturn.push(<Tooltip h6="09/09/2018" placement="top">
    //            <AlertChip
    //                TLight="true"
    //                color="high"
    //                avatar={flags.high}
    //            />
    //        </Tooltip>);
    //    }
    //    if (flags.mid) {
    //        toReturn.push(<Tooltip h6="09/09/2018" placement="top">
    //            <AlertChip
    //                TLight="true"
    //                color="mid"
    //                avatar={flags.mid}
    //            />
    //        </Tooltip>)
    //    }
    //    if (flags.low) {
    //        toReturn.push(<Tooltip h6="09/09/2018" placement="top">
    //            <AlertChip
    //                TLight="true"
    //                color="low"
    //                avatar={flags.low}
    //            />
    //        </Tooltip>)
    //    }
    //    return <div>{toReturn}</div>;
    //}

    _onChangeSearch(e){
        //console.log(e.target.value);
        if (e.target.value){
            var filtered = this.state.data.filter(function(itm){
                return itm.name.toLowerCase().includes(e.target.value.toLowerCase())
            });
        } else {
            var filtered = this.state.data
        }
        
        //console.log(filtered);
        this.setState({filtered: filtered})
    }

    render() {
        const { classes, theme } = this.props;
        const { data, order, orderBy, selected, rowsPerPage, page, anchor, open, details, list, filtered,detailSelected } = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
        // console.log("vendor filtered")
        // console.log(this.state.filtered, rowsPerPage, page, page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        const detailsView = (<Grid item md={9} className={classes.contentWrapper}>
            <VendorListDetail detailID={detailSelected}/>
        </Grid>);

        const content_height = (this.state.height - 252) + "px";
        const content_style = {
            height: content_height,
        };

        return (
            <div className={classes.root} style={content_style}>
                {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                <Grid container spacing={grid_spacing} >
                    <Grid item md={3} >
                        <Card className={classes.tableWrapper}>

                            <CustomizedTable
                                tableHeader = {["Vendor Name"]}
                                data = {filtered
                                        .sort(getSorting(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
                                tableHeaderMap = {{"Vendor Name":'name'}}
                                searchBar = {true}
                                tableStyle = {'tall'}
                                //rowHeight = {'60px'}
                                clickEvent = {this.handleAction}
                            />
                            {/* line 440 - 534*/}
                            <TablePagination 
                                component="Table"
                                count={filtered.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </Card>
                    </Grid>
                    {this.state.details ? detailsView : null}
                </Grid>
                <Divider />

            </div>
        );
    }
}

VendorAlertTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(VendorAlertTable);




                      
//                            {searchBar}
//                            <Table className={classes.table} aria-labelledby="tableh6">
//                                <EnhancedTableHead
//                                    numSelected={selected.length}
//                                    order={order}
//                                    orderBy={orderBy}
//                                    onSelectAllClick={this.handleSelectAllClick}
//                                    onRequestSort={this.handleRequestSort}
//                                    rowCount={data.length}
//                                />
//                                <TableBody>
//                                    {filtered
//                                        .sort(getSorting(order, orderBy))
//                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                                        .map(n => {
//                                            // console.log(n)
//                                            const isSelected = this.isSelected(n.id);
//                                            let i = 0;
//                                            return (
//                                                <TableRow
//                                                    hover
//                                                    style={{height: '60px'}}
//                                                    role="checkbox"
//                                                    aria-checked={isSelected}
//                                                    tabIndex={-1}
//                                                    key={n.id}
//                                                    selected={isSelected}
//                                                    padding
//                                                 >
//                                                    <TableCell padding="checkbox"
//                                                        /*onClick={event => this.handleClick(event, n.id)}*/>
//                                                        {/* <Checkbox checked={isSelected} /> */}
//                                                    </TableCell>
//                                                    <TableCell component="th" scope="row" padding="none" onClick={event => this.handleAction(event, n.id)} key={n.id}>
//                                                        {n.name}
//                                                    </TableCell>
//                                                    {/* <TableCell>{this.renderChips(n.flags)}</TableCell> */}
//                                                    {
//                                                        this.state.fields.map(f => {
//                                                            if(f =="flags"){
//                                                                return(<TableCell style={{ position: "sticky", left: "3vw"   }}>
//                                                                    {n.flags["High Risk"].map(e => {
//                                                                        i++;
//                                                                        return (<AlertChip
//                                                                            key={i}
//                                                                            label={n.flags["High Risk"].length}
//                                                                            color={'high'}
//                                                                            username={this.props.username}
//                                                                            taskRefresh = {this.props.taskRefresh}
//                                                                            metadata = {this.props.metadata}
//                                                                            //avatar={n.flags.hightr}
//                                                                            //style={{ margin: 2 }}
//                                                                        />)
//                                                                    })}
//                                                                    {n.flags["Medium Risk"].map(e => {
//                                                                        i++;
//                                                                        return (<AlertChip
//                                                                            key={i}
//                                                                            label={n.flags["Medium Risk"].length}
//                                                                            color={'mid'}
//                                                                            username={this.props.username}
//                                                                            taskRefresh = {this.props.taskRefresh}
//                                                                            metadata = {this.props.metadata}
//                                                                            //avatar={n.flags.hightr}
//                                                                            //style={{ margin: 2 }}
//                                                                        />)
//                                                                    })}
//                                                                    {n.flags["Low Risk"].map(e => {
//                                                                        i++;
//                                                                        return (<AlertChip
//                                                                            key={i}
//                                                                            label={n.flags["Low Risk"].length}
//                                                                            color={'low'}
//                                                                            username={this.props.username}
//                                                                            taskRefresh = {this.props.taskRefresh}
//                                                                            metadata = {this.props.metadata}
//                                                                            //avatar={n.flags.hightr}
//                                                                            //style={{ margin: 2 }}
//                                                                        />);
//                                                                    })}
//                                                                    </TableCell>)
//                                                            }
//                                                        })
//                                                    }
//
//                                                </TableRow>
//                                            );
//                                        })}
//                                    {emptyRows > 0 && (
//                                        <TableRow style={{ height: 49 * emptyRows }}>
//                                            <TableCell colSpan={6} />
//                                        </TableRow>
//                                    )}
//                                </TableBody>
//                            </Table>



// WEBPACK FOOTER //
// ./src/components/Entities/vendor/EmployeeAlertTable.js